import { Pontos } from "../../class/pontos";
export default {
    data() {
        return {
            user: null,
            cliente: {}
        };
    },
    methods: {
        loadPonto() {
            if (this.$route.params.id) {
                Pontos.byID(this.$route.params.id)
                    .then(row => this.$store.commit("setPonto", row))
                    .catch(() =>
                        this.$store.commit("setPonto", Pontos.create())
                    );
            }
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.loadPonto(this.$route.params.id);
        } else {
            this.$store.commit("setPonto", Pontos.create());
        }
    }
};
